import { NzModalService } from 'ng-zorro-antd/modal';
import { listOfValues } from '../models/listOfValues.model';

export const datesAreOnSameDay = (first: Date, second: Date) =>
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate();

export const isEmpty = (value: any): boolean => {
    if (typeof value === 'object') {
        return Object.entries(value).length === 0;
    } else if (typeof value === 'string') {
        return value === undefined || value === null || value === '';
    } else {
        return false;
    }
};

export function isNumber(cadena: string): boolean {
    if (cadena.trim() === '') {
        return false; // O manejar de cualquier otra manera que necesites
    }
    return !isNaN(parseFloat(cadena)) && isFinite(Number(cadena));
}

export function isEmail(cadena: string): boolean {
    return String(cadena)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        )
        ? true
        : false;
}

export function extractValueObjectDictionary(list: any[]) {
    const objects: any[] = [];
    list.map((element) => {
        objects.push({ name: element.name, id: element.id });
    });
    return objects;
}

export function extractValuesToList(list: any[]) {
    const listOfValue: listOfValues[] = [];

    list.map((element) => {
        listOfValue.push({ id: element.id, name: element.text });
    });
    return listOfValue;
}

export function isValidIpAddress(ip: string): boolean {
    const regex = /^(\d{1,3}\.){3}\d{1,3}$/;
    if (!regex.test(ip)) {
        return false;
    }

    const segments = ip.split('.').map(Number);
    for (const segment of segments) {
        if (segment < 0 || segment > 255 || !Number.isInteger(segment)) {
            return false;
        }
    }

    return true;
}

export function millisToString(millisec: number): string {
    let seconds: number = +(millisec / 1000).toFixed(0);
    let minutes: number = Math.floor(seconds / 60);
    let hours: number = 0;

    if (minutes > 59) {
        hours = Math.floor(minutes / 60);
        minutes = minutes - hours * 60;
    }

    seconds = Math.floor(seconds % 60);

    if (hours > 0) {
        return `${hours >= 10 ? '' : '0'}${hours} h. ${minutes >= 10 ? '' : '0'}${minutes} min. ${seconds >= 10 ? '' : '0'}${seconds} sec.`;
    }

    return `${minutes >= 10 ? '' : '0'}${minutes} min. ${seconds >= 10 ? '' : '0'}${seconds} sec.`;
}

export function millisToHHmmss(millisec: number): { hours: number, minutes: number, seconds: number } {
    let seconds: number = +(millisec / 1000).toFixed(0);
    let minutes: number = Math.floor(seconds / 60);
    let hours: number = 0;

    if (minutes > 59) {
        hours = Math.floor(minutes / 60);
        minutes = minutes - hours * 60;
    }

    seconds = Math.floor(seconds % 60);

    return { hours, minutes, seconds };
}

export function HHmmssToMillis(hours: number, minutes: number, seconds: number): number {
    const millis = (hours * 60 * 60 + minutes * 60 + seconds) * 1000;

    return millis;
}

export function showDialog(modalService: NzModalService, title: string, htmlContent?: string): Promise<boolean> {
    return new Promise((resolve) => {
        modalService.confirm({
            nzTitle: `<i>${title}</i>`,
            nzContent: htmlContent,
            nzClosable: false,
            nzOkText: 'Aceptar',
            nzOnOk: () => { resolve(true); },
            nzCancelText: 'Cancelar',
            nzOnCancel: () => { resolve(false); }
        });
    });
}

export function makeid(length: number): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export function getLastError(obj: any): any {
    if (obj && typeof obj === 'object' && obj.error) {
        return getLastError(obj.error);
    }
    return obj;
}

/**
 * Normaliza el nombre de proceso para comparaciones confiables.
 * - Recorta espacios
 * - Convierte a minúsculas
 * - Elimina tildes/diacríticos
 */
export function normalizeProcessName(name?: string): string {
    return (name ?? '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

/**
 * Determina si el proceso usa unidad MML (metros lineales).
 */
export function isMmlProcessName(name?: string): boolean {
    const normalizedName = normalizeProcessName(name);
    const mmlProcessNames = ['flexografia', 'laminado', 'rebobinado'];
    return mmlProcessNames.includes(normalizedName);
}

/**
 * Determina si el proceso usa unidad UD (unidades).
 */
export function isUdProcessName(name?: string): boolean {
    const normalizedName = normalizeProcessName(name);
    const udProcessNames = ['confeccion'];
    return udProcessNames.includes(normalizedName);
}

/**
 * Devuelve la unidad de medida a mostrar según el proceso de producción
 * - Si se pasa productionProcessName utiliza isMmlProcessName/isUdProcessName
 * - Si se pasa productionProcessId utiliza la correspondencia por id (1,2,3 => MML; 4 => UD)
 * - En caso contrario devuelve la abreviatura de fallback si se provee o cadena vacía
 */
export function getDisplayUnit(productionProcessId?: number, productionProcessName?: string, fallbackAbbreviation?: string): string {
    if (productionProcessName) {
        if (isMmlProcessName(productionProcessName)) {
            return 'MML';
        } else if (isUdProcessName(productionProcessName)) {
            return 'UD';
        }
    }
    if (productionProcessId && [1, 2, 3].includes(productionProcessId)) {
        return 'MML';
    } else if (productionProcessId === 4) {
        return 'UD';
    }
    return fallbackAbbreviation || '';
}
